import { IconSvgElement } from "@hugeicons/react";
import { formatNavBadgeCount } from "../use-nav-item-counts";
import { useRentReportingNavCount } from "../use-rent-reporting-nav-count";
import { NavLink } from "./NavLink";

export const RentReportingNavLink = ({
  name,
  to,
  Icon
}: {
  name: string;
  to: string;
  Icon: IconSvgElement;
}) => {
  const count = useRentReportingNavCount();

  return (
    <NavLink
      to={to}
      HugeIcon={Icon}
      indicator={count > 0 ? formatNavBadgeCount(count) : undefined}
    >
      {name}
    </NavLink>
  );
};
